import axios from "axios";
import { toast } from "react-toastify";
import { push } from "connected-react-router";

export const YELLOW_GET_ARTICLES_REQUEST = "YELLOW_GET_USERS_REQUEST";
export const YELLOW_GET_ARTICLES_SUCCESS = "YELLOW_GET_ARTICLES_SUCCESS";
export const YELLOW_GET_ARTICLES_FAIL = "YELLOW_GET_ARTICLES_FAIL";
export const getArticles = params => dispatch => {
  dispatch({
    type: YELLOW_GET_ARTICLES_REQUEST
  });
  axios
    .request({
      url: "yellow_pages",
      params: params,
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: YELLOW_GET_ARTICLES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: YELLOW_GET_ARTICLES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const YELLOW_GET_CATEGORIES_REQUEST = "YELLOW_GET_CATEGORIES_REQUEST";
export const YELLOW_GET_CATEGORIES_SUCCESS = "YELLOW_GET_CATEGORIES_SUCCESS";
export const YELLOW_GET_CATEGORIES_FAIL = "YELLOW_GET_CATEGORIES_FAIL";
export const getCategories = ({ category_id }) => dispatch => {
  dispatch({
    type: YELLOW_GET_CATEGORIES_REQUEST
  });
  axios
    .request({
      url: "category",
      params: {
        id: category_id
      },
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: YELLOW_GET_CATEGORIES_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: YELLOW_GET_CATEGORIES_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const YELLOW_REMOVE_ARTICLE_REQUEST = "YELLOW_REMOVE_ARTICLE_REQUEST";
export const YELLOW_REMOVE_ARTICLE_SUCCESS = "YELLOW_REMOVE_ARTICLE_SUCCESS";
export const YELLOW_REMOVE_ARTICLE_FAIL = "YELLOW_REMOVE_ARTICLE_FAIL";
export const removeArticle = post_id => dispatch => {
  dispatch({
    type: YELLOW_REMOVE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/yellow_page/remove",
      data: {
        yellow_page_id: post_id
      },
      method: "post"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: YELLOW_REMOVE_ARTICLE_SUCCESS
        });
        toast.success(data.message);
        dispatch(push("/dash/admin/yellow-pages"));
      } else {
        dispatch({
          type: YELLOW_REMOVE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const YELLOW_GET_ARTICLE_REQUEST = "YELLOW_GET_ARTICLE_REQUEST";
export const YELLOW_GET_ARTICLE_SUCCESS = "YELLOW_GET_ARTICLE_SUCCESS";
export const YELLOW_GET_ARTICLE_FAIL = "YELLOW_GET_ARTICLE_FAIL";
export const getArticle = id => dispatch => {
  dispatch({
    type: YELLOW_GET_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "yellow_page",
      params: {
        yellow_page_id: id
      },
      method: "GET"
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: YELLOW_GET_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
      } else {
        dispatch({
          type: YELLOW_GET_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        // toast.warn(data.message);
      }
    });
};

export const YELLOW_EDIT_ARTICLE_REQUEST = "YELLOW_EDIT_ARTICLE_REQUEST";
export const YELLOW_EDIT_ARTICLE_SUCCESS = "YELLOW_EDIT_ARTICLE_SUCCESS";
export const YELLOW_EDIT_ARTICLE_FAIL = "YELLOW_EDIT_ARTICLE_FAIL";
export const editArticle = ({
  yellow_page_id,
  category_id,
  title,
  body,
  cover_img,
  contact,
  email,
  phone,
  address,
  website,
  promo_image,
  is_promoted
}) => dispatch => {
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("yellow_page_id", yellow_page_id);
  params.append("category_id", category_id);
  params.append("title", title);
  params.append("body", body);
  params.append("contact", contact);
  params.append("phone", phone);
  params.append("address", address);
  if (cover_img) params.append("cover_image", cover_img);
  if (email) params.append("email", email);
  if (website) params.append("website", website);
  params.append("is_promoted", is_promoted ? 1 : 0);
  if (promo_image) params.append("promo_image", promo_image);
  dispatch({
    type: YELLOW_EDIT_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/yellow_page/edit",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: YELLOW_EDIT_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/admin/yellow-pages"));
      } else {
        dispatch({
          type: YELLOW_EDIT_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        toast.warn(data.message);
      }
    });
};

export const YELLOW_CREATE_ARTICLE_REQUEST = "YELLOW_CREATE_ARTICLE_REQUEST";
export const YELLOW_CREATE_ARTICLE_SUCCESS = "YELLOW_CREATE_ARTICLE_SUCCESS";
export const YELLOW_CREATE_ARTICLE_FAIL = "YELLOW_CREATE_ARTICLE_FAIL";
export const createArticle = ({
  category_id,
  title,
  body,
  cover_img,
  contact,
  email,
  phone,
  address,
  website,
  promo_image,
  is_promoted
}) => dispatch => {
  let params = new FormData(); //如果需要上传多张图片,需要遍历数组,把图片的路径数组放入formData中
  params.append("category_id", category_id);
  params.append("title", title);
  params.append("body", body);
  params.append("contact", contact);
  params.append("phone", phone);
  params.append("address", address);
  if (cover_img) params.append("cover_image", cover_img);
  if (email) params.append("email", email);
  if (website) params.append("website", website);
  params.append("is_promoted", is_promoted ? 1 : 0);
  if (promo_image) params.append("promo_image", promo_image);

  dispatch({
    type: YELLOW_CREATE_ARTICLE_REQUEST
  });
  axios
    .request({
      url: "dashboard/yellow_page/create",
      data: params,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(({ data }) => {
      if (data.success) {
        dispatch({
          type: YELLOW_CREATE_ARTICLE_SUCCESS,
          msg: data.message,
          data: data.data
        });
        dispatch(push("/dash/admin/yellow-pages"));
      } else {
        dispatch({
          type: YELLOW_CREATE_ARTICLE_FAIL,
          msg: data.message,
          errors: data.errors ? data.errors : {}
        });
        toast.warn(data.message);
      }
    });
};
